import React, { useEffect, useState } from "react";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Button, Col, Row, Form } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import * as yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  get_single_page,
  add_section,
} from "../../../../../store/actions/Experience/adminExperienceAction";
import { errorAlert, successAlert } from "../../../../../function/alert";

const validationSchema = yup.object({
  section_id: yup
    .number()
    .typeError("Section ID should be a number")
    .required("Section ID is required."),
  section_position: yup
    .number()
    .typeError("Section position should be a number")
    .required("Section position is required."),
  section_description: yup.string().required("Descripion is required."),
});

const AddSection = () => {
  const dispatch = useDispatch();
  const { page_id } = useParams();
  const auth = useSelector((state) => state.auth);
  const history = useHistory();
  const [pageData, setPageData] = useState({});
  const page = useSelector((state) =>
    state?.superAdminExperience?.pages.filter((e) => e?._id === page_id)
  );

  useEffect(() => {
    if (!page?.length)
      dispatch(get_single_page(auth?.user?.accessToken, page_id));
  }, []);

  const formik = useFormik({
    initialValues: {
      page_id: "",
      page_description: "",
      section_id: "",
      section_position: "",
      section_description: "",
    },
    validationSchema,
    onSubmit: (values) => {
      let _flag = false;
      for (let index = 0; index < pageData?.sections.length; index++) {
        const element = pageData?.sections[index];
        if (element?.position == values?.section_position) _flag = true;
      }
      if (_flag) {
        errorAlert("Section position already exists");
      } else {
        let formData = pageData || {};
        formData.sections = [...formData.sections];
        formData.sections.push({
          section_id: values?.section_id,
          position: values?.section_position,
          description: values?.section_description,
          createdAt: new Date(),
          updatedAt: new Date(),
        });
        dispatch(
          add_section(page_id, formData, auth?.user?.accessToken, onSuccess)
        );
      }
    },
  });

  const onSuccess = (e) => {
    successAlert("Section added successfully.");
    history.goBack();
  };

  useEffect(() => {
    if (page?.length) {
      formik.setFieldValue("page_id", page[0].page_id);
      formik.setFieldValue("page_description", page[0].description);
      setPageData(page[0]);
      formik.setFieldValue("section_id", page[0].sections.length + 1);
    }
  }, [page?.length]);

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">Add Section</div>
              </div>
              <hr />
              <Form>
                <Row>
                  <Col md={4}>
                    <Form.Group className="pb-4">
                      <div className="f16-700 mr-2 my-2"> Page ID</div>
                      <TextField
                        id="page_id"
                        label="Page ID"
                        type="text"
                        variant="outlined"
                        className={`w-100`}
                        name="page_id"
                        value={formik.values?.page_id || ""}
                        disabled
                      />

                      {formik.errors.page_id && formik.touched.page_id ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.page_id}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={8}>
                    <Form.Group className="pb-4">
                      <div className="f16-700 mr-2 my-2"> Description</div>
                      <TextField
                        id="page_description"
                        label="Add Description"
                        type="text"
                        variant="outlined"
                        className={`w-100`}
                        name="page_description"
                        value={formik.values?.page_description || ""}
                        disabled
                      />

                      {formik.errors.page_description &&
                      formik.touched.page_description ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.page_description}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <Form.Group className="pb-4">
                      <div className="f16-700 mr-2 my-2"> Selection ID</div>
                      <TextField
                        id="section_id"
                        label="Add Selection"
                        type="text"
                        variant="outlined"
                        className={`w-100`}
                        name="section_id"
                        disabled
                        value={formik.values?.section_id || ""}
                        // onChange={formik.handleChange}
                      />

                      {formik.errors.section_id && formik.touched.section_id ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.section_id}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <Form.Group className="pb-4">
                      <div className="f16-700 mr-2 my-2"> Section Position</div>
                      <TextField
                        id="section_position"
                        label="Selection position"
                        type="text"
                        variant="outlined"
                        className={`w-100`}
                        name="section_position"
                        value={formik.values?.section_position || ""}
                        onChange={formik.handleChange}
                      />

                      {formik.errors.section_position &&
                      formik.touched.section_position ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.section_position}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={8}>
                    <Form.Group className="pb-4">
                      <div className="f16-700 mr-2 my-2">
                        {" "}
                        Section Description
                      </div>
                      <TextField
                        id="section_description"
                        label="Selection Description"
                        type="text"
                        variant="outlined"
                        className={`w-100`}
                        name="section_description"
                        value={formik.values?.section_description || ""}
                        onChange={formik.handleChange}
                      />

                      {formik.errors.section_description &&
                      formik.touched.section_description ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.section_description}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
                <div className="py-4 d-flex align-items-center">
                  <Button
                    variant="outline-secondary"
                    className="btn-lg mr-4 px-5 btn150px"
                    type="button"
                    onClick={() => history.goBack()}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="danger"
                    className="btn-lg px-5 btn150px"
                    type="button"
                    onClick={formik.handleSubmit}
                    disabled={!page_id}
                  >
                    Save
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default AddSection;
